/* Top bar (snippets/pb-topbar): menu panel, Shop panel, Bags / Accessories tabs, cart.
   - One panel open at a time. Closes on a tap or click outside, Escape, a page scroll, a width change, and pageshow.
   - The phone menu is a drawer with a scrim and a page lock (html.pbt-lock); every close path releases the lock.
   - Panels are fixed and shown with opacity / visibility only; their place is set from the button on open.
   - Tabs: on the homepage they scroll (eased, window.pbEaseScroll) to the bag and accessories sections and follow the scroll;
     elsewhere they read Shop bags / Shop accessories and link.
   - Search pill (desktop): grows into the search field over a fading frost, and shrinks back on close.
   - The bar's height is published as --pb-float-h (with html.pb-float-on), so pinned page parts park below it. */
(function () {
  if (window.__pbTopbar) return;
  var D = document, H = D.documentElement;
  var dock = D.getElementById('pbt-dock'), bar = D.getElementById('pbt-bar');
  if (!dock || !bar) return;
  window.__pbTopbar = 1;
  var scrim = D.getElementById('pbt-scrim');
  var P = { m: D.getElementById('pbt-menu'), s: D.getElementById('pbt-shop') };
  var T = { m: D.getElementById('pbt-menu-btn'), s: D.getElementById('pbt-shop-btn') };
  var cur = null, y0 = 0, w0 = 0, locked = false;
  function phone() { return window.innerWidth < 750; }
  function store(n) { try { return window.Alpine && Alpine.store ? Alpine.store(n) : null; } catch (e) { return null; } }

  /* bar height for pinned page parts */
  var lastH = -1;
  function publish() {
    var h = Math.round(bar.offsetHeight);
    if (!h || h === lastH) return;
    lastH = h;
    H.style.setProperty('--pbt-h', h + 'px');
    H.style.setProperty('--pb-float-h', h + 'px');
    H.classList.add('pb-float-on');
  }
  publish();
  window.addEventListener('load', publish);

  if (D.fonts && D.fonts.ready) D.fonts.ready.then(publish);

  /* page lock for the phone drawer: html overflow hidden (never a pinned body) */
  function lock(on) {
    if (on === locked) return;
    locked = on;
    var y = window.scrollY;
    H.classList.toggle('pbt-lock', on);
    if (!on && Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
  }

  /* blur cues on every scroller in a panel */
  function cues(root) {
    [].forEach.call(root.querySelectorAll('.pbt-scw'), function (w) {
      var sc = w.querySelector(':scope > .pbt-sc'); if (!sc) return;
      var over = sc.scrollHeight > sc.clientHeight + 2 && getComputedStyle(sc).overflowY !== 'visible';
      w.classList.toggle('more-t', over && sc.scrollTop > 2);
      w.classList.toggle('more-b', over && sc.scrollTop + sc.clientHeight < sc.scrollHeight - 2);
    });
  }
  Object.keys(P).forEach(function (k) {
    if (!P[k]) return;
    [].forEach.call(P[k].querySelectorAll('.pbt-sc'), function (sc) {
      sc.addEventListener('scroll', function () { cues(P[k]); }, { passive: true });
    });
  });

  function place(k) {
    var p = P[k], b = T[k].getBoundingClientRect(), vw = H.clientWidth || window.innerWidth;
    var top = Math.round(b.bottom + 8);
    p.style.setProperty('--pbt-pt', top + 'px');
    p.style.top = top + 'px';
    if (phone()) {
      /* phones: full width with 12px gutters, as tall as the visible viewport (Safari's toolbar included), the
         content scrolls inside with room for the home indicator */
      var vv = window.visualViewport, vh = vv ? vv.height + (vv.offsetTop || 0) : window.innerHeight;
      p.style.left = '12px'; p.style.right = '12px'; p.style.bottom = '';
      p.style.width = 'auto';
      var hgt = Math.max(240, Math.round(vh - top - 12));
      if (k === 'm') p.style.height = hgt + 'px'; else p.style.height = '';
      p.style.maxHeight = hgt + 'px';
    } else {
      p.style.width = ''; p.style.height = ''; p.style.maxHeight = '';
      p.style.right = ''; p.style.bottom = '';
      var left = k === 's' ? b.right - p.offsetWidth : b.left;
      if (k === 's' && window.innerWidth >= 1024) {   /* desktop: centred under the middle group (tabs and Shop) */
        var sg = D.getElementById('pbt-seg'), a1 = sg ? sg.getBoundingClientRect().left : b.left, a2 = b.right;
        left = (a1 + a2) / 2 - p.offsetWidth / 2;
      }
      left = Math.max(14, Math.min(left, vw - p.offsetWidth - 14));
      p.style.left = Math.round(left) + 'px';
    }
  }
  /* where the panel grows from / shrinks to: the button's centre-bottom, relative to the panel */
  function seed(k) {
    var p = P[k], pr = p.getBoundingClientRect(), b = T[k].getBoundingClientRect();
    p.style.setProperty('--pbt-ox', Math.round((b.left + b.right) / 2 - pr.left) + 'px');
    p.style.setProperty('--pbt-oy', Math.round(b.bottom - pr.top) + 'px');
  }
  function focusables(root) {
    return [].filter.call(root.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])'), function (el) {
      return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert]') && !el.closest('[hidden]');
    });
  }
  function open(k) {
    if (cur === k) { close(true); return; }
    close(false);
    if (!P[k] || !T[k]) return;
    cur = k; y0 = window.scrollY; w0 = window.innerWidth;
    place(k);
    seed(k);
    [].forEach.call(P[k].querySelectorAll('.pbt-sc'), function (sc) { sc.scrollTop = 0; });
    P[k].classList.add('is-on'); H.classList.add('pbt-open');
    T[k].setAttribute('aria-expanded', 'true');
    if (k === 'm' && phone()) { scrim.classList.add('is-on'); lock(true); }
    if (k === 'm' && window.pbTopbarDv) { window.pbTopbarDv.reset(); } /* always open at the root (Home, Shop bags...); the branch holding this page keeps its dot (src M-1C61) */
    requestAnimationFrame(function () { cues(P[k]); });
    setTimeout(function () {
      if (cur !== k) return;
      var ins = k === 'm' ? P[k].querySelectorAll('.pbt-dv.is-in [data-pbt-back]') : [];
      var f = k === 'm' ? (ins.length ? ins[ins.length - 1] : P[k].querySelector('[data-pbt-search]')) : P[k].querySelector('a[href]');
      if (f) try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    }, 60);
  }
  function close(back) {
    if (!cur) { lock(false); H.classList.remove('pbt-open'); return; }
    var k = cur; cur = null;
    P[k].classList.remove('is-on'); H.classList.remove('pbt-open');
    if (k === 'm' && window.pbTopbarDv) setTimeout(function () { if (cur !== 'm') window.pbTopbarDv.reset(); }, 450);
    T[k].setAttribute('aria-expanded', 'false');
    scrim.classList.remove('is-on');
    lock(false);
    if (back) try { T[k].focus({ preventScroll: true }); } catch (e) { T[k].focus(); }
  }
  window.pbTopbarClose = function () { close(false); };

  /* eased page scroll (ease-in-out, 600-900 ms by distance; beyond two screens a jump to one screen short, then a
     500 ms ease) on requestAnimationFrame; instant under reduced motion.
     The target may be a function (re-read each frame, so late layout still lands). Any wheel, touch or key hands
     the page straight back to the visitor: nothing is locked or held. */
  function easeScroll(target, done) {
    var tgt = typeof target === 'function' ? target : function () { return target; };
    var y0 = window.pageYOffset || 0, d0 = Math.abs(tgt() - y0);
    var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rm || d0 < 2) { window.scrollTo(0, tgt()); if (done) done(); return; }
    var dur = Math.max(600, Math.min(900, 600 + d0 / 10)), t0 = 0, stop = false, ended = false;
    var ss = H.style.scrollSnapType, sb = H.style.scrollBehavior;
    H.style.scrollSnapType = 'none'; H.style.scrollBehavior = 'auto';
    /* a long way (more than two screens): jump to one screen short of the target, then ease the last stretch, so the
       page never renders everything in between (the homepage animation reads the scroll position, not the path) */
    var vh = window.innerHeight || 800;
    if (d0 > 2 * vh) {
      var t1 = tgt(), dir = t1 > y0 ? 1 : -1;
      window.scrollTo(0, Math.round(t1 - dir * vh));
      y0 = window.pageYOffset || 0; dur = 500;
    }
    function quit() { stop = true; }
    /* one scroll for listeners that wait for its end: the per-frame steps do not each report a scrollend */
    function hush(e) { if (!ended && e.isTrusted) e.stopImmediatePropagation(); }
    var evs = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    evs.forEach(function (n) { window.addEventListener(n, quit, { capture: true, passive: true }); });
    window.addEventListener('scrollend', hush, true);
    function fin() {
      if (ended) return; ended = true;
      evs.forEach(function (n) { window.removeEventListener(n, quit, true); });
      H.style.scrollSnapType = ss; H.style.scrollBehavior = sb;
      setTimeout(function () { window.removeEventListener('scrollend', hush, true); try { window.dispatchEvent(new Event('scrollend')); } catch (x) {} }, 60);
      if (done) done();
    }
    function ease(p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
    function step(t) {
      if (stop) { fin(); return; }
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      window.scrollTo(0, Math.round(y0 + (tgt() - y0) * ease(p)));
      if (p < 1) requestAnimationFrame(step); else fin();
    }
    requestAnimationFrame(step);
  }
  window.pbEaseScroll = easeScroll;

  /* search: the pill grows into the store's search field (ghost pill, geometry only) while the page frosts over;
     on close it shrinks back into the pill. Desktop pill only; reduced motion opens and closes in place. */
  var sbtn = D.getElementById('pbt-sbtn'), ghost = D.getElementById('pbt-ghost'), frost = D.getElementById('pbt-frost');
  var gT = 0, gField = null, gOpen = false, gTarget = null;
  function rm() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function pillOn() { return sbtn && sbtn.getClientRects().length && getComputedStyle(sbtn).display !== 'none'; }
  function fieldEl() {
    var l = D.querySelectorAll('#FormSearch:not(.popup-hidden) .input-search');
    for (var i = 0; i < l.length; i++) if (l[i].getClientRects().length) return l[i];
    return null;
  }
  function gBox(r) { ghost.style.left = Math.round(r.left) + 'px'; ghost.style.top = Math.round(r.top) + 'px'; ghost.style.width = Math.round(r.width) + 'px'; ghost.style.height = Math.round(r.height) + 'px'; }
  function gReset() { clearTimeout(gT); ghost.classList.remove('is-on', 'is-go', 'is-off'); H.classList.remove('pbt-sx'); }
  function morphOpen() {
    if (!ghost || !pillOn() || rm()) return false;
    gReset();
    var r0 = sbtn.getBoundingClientRect();
    /* the field opens on the pill's row, centred (same numbers as pb-search.js topOf) */
    var vw = H.clientWidth || window.innerWidth;
    H.style.setProperty('--pbs-top', Math.round(window.innerWidth >= 1024 ? r0.top : (window.innerWidth < 750 ? 8 : r0.top + r0.height / 2 - 24)) + 'px');
    H.setAttribute('data-pbs-placed', String(Date.now()));
    var W = Math.round(Math.min(706, vw - 150)) + 54;
    gTarget = { left: Math.round((vw - (W - 54)) / 2), top: Math.round(r0.top), width: W - 54, height: Math.round(r0.height) };   /* field + gap + close; the field itself is centred */   /* centred final field (same numbers as pb-search.js topOf) */
    H.style.setProperty('--pbs-right', Math.round((vw - (W - 54)) / 2 - 54) + 'px');
    H.style.setProperty('--pbs-w', W + 'px');
    gBox(r0);
    ghost.classList.add('is-on'); H.classList.add('pbt-sx');
    var n = 0;
    (function wait() {
      var f = fieldEl();
      if (!f) { if (++n < 40) { gT = setTimeout(wait, 50); return; } gReset(); return; }
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        /* desktop: the field's final box is known from the numbers set above (it may still be settling): aim there */
        gField = f.getBoundingClientRect();
        if (window.innerWidth >= 1024 && gTarget) gField = gTarget;
        gOpen = true;
        ghost.offsetWidth; ghost.classList.add('is-go'); gBox(gField);
        gT = setTimeout(function () { H.classList.remove('pbt-sx'); ghost.classList.add('is-off'); gT = setTimeout(function () { ghost.classList.remove('is-on', 'is-go', 'is-off'); }, 200); }, 460);
      }); });
    })();
    return true;
  }
  function morphClose() {
    if (!gOpen) return; gOpen = false;
    if (!ghost || !gField || !pillOn() || rm()) { gReset(); return; }
    gReset();
    gBox(gField); ghost.classList.add('is-on'); H.classList.add('pbt-sx');
    requestAnimationFrame(function () {
      ghost.offsetWidth; ghost.classList.add('is-go'); gBox(sbtn.getBoundingClientRect());
      gT = setTimeout(function () { H.classList.remove('pbt-sx'); ghost.classList.add('is-off'); gT = setTimeout(function () { ghost.classList.remove('is-on', 'is-go', 'is-off'); }, 200); }, 460);
    });
  }
  if (window.MutationObserver) {
    var sOpen = H.classList.contains('pbs-open');
    new MutationObserver(function () {
      var o = H.classList.contains('pbs-open'); if (o === sOpen) return; sOpen = o;
      if (!o) morphClose();
    }).observe(H, { attributes: true, attributeFilter: ['class'] });
  }
  if (frost) frost.addEventListener('click', function () { var b = D.getElementById('SearchClose'); if (b && H.classList.contains('pbs-open')) b.click(); });
  window.addEventListener('resize', function () { if (gOpen && !H.classList.contains('pbs-open')) gReset(); }, { passive: true });

  /* the store's search layer (the header keeps it): opened through its own button */
  function openSearch(from) {
    close(false);
    var n = 0, morph = from === sbtn;
    (function go() {
      var f = D.getElementById('FormSearch'), host = f && f.closest('[x-data]'), b = host && host.querySelector('#SearchOpen');
      if (b) { if (morph) morphOpen(); b.click(); return; }
      /* the store renders its search layer on the first pointer move; ask for it, then wait a moment */
      if (n === 0) try { D.body.dispatchEvent(new MouseEvent('mouseover', { bubbles: true })); } catch (e) {}
      /* before the store's scripts start (slow load) go to the search page after 1.5 s rather than leave the tap unanswered (PB-1253) */
      if (++n < (window.Alpine ? 60 : 15)) setTimeout(go, 100); else location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search';
    })();
  }

  D.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var o = t.closest('[data-pbt-open]');
    if (o && bar.contains(o)) { e.preventDefault(); open(o.getAttribute('data-pbt-open')); return; }
    if (t.closest('[data-pbt-close]')) { close(true); return; }
    if (t.closest('[data-pbt-search]')) { e.preventDefault(); openSearch(t.closest('[data-pbt-search]')); return; }
    var a = t.closest('.pbt-acc > button[aria-controls], .pbt-gt[aria-controls]');
    if (a) {
      var x = a.getAttribute('aria-expanded') === 'true', g = D.getElementById(a.getAttribute('aria-controls'));
      a.setAttribute('aria-expanded', x ? 'false' : 'true'); if (g) g.hidden = x;
      var pp = a.closest('.pbt-pnl'); if (pp) cues(pp);
      return;
    }
    if (cur && t.closest('.pbt-pnl a[href]')) { close(false); return; }
  });
  D.addEventListener('pointerdown', function (e) {
    if (!cur) return;
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.pbt-pnl') || t.closest('[data-pbt-open]')) return;
    close(false);
  }, { capture: true, passive: true });
  D.addEventListener('keydown', function (e) {
    if (!cur) return;
    if (e.key === 'Escape') { e.stopPropagation(); close(true); return; }
    if (e.key === 'Tab' && cur === 'm' && phone()) {
      var f = focusables(P.m); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }, true);
  window.addEventListener('scroll', function () {
    if (cur && !locked && Math.abs(window.scrollY - y0) > 6) close(false);
  }, { passive: true });
  window.addEventListener('resize', function () {
    publish();
    if (!cur) return;
    if (Math.abs(window.innerWidth - w0) > 1) close(false); else { place(cur); cues(P[cur]); }
  }, { passive: true });
  window.addEventListener('pageshow', function () { close(false); lock(false); });
  if (window.visualViewport) visualViewport.addEventListener('resize', function () { if (cur && phone()) place(cur); });
  window.addEventListener('pagehide', function () { close(false); });

  /* you are here: panel and drawer links to this page (same path, same filter / tag view; on a product page reached
     through a collection, that collection) read cobalt with an orange dot; the closed Shop pill and the Bags /
     Accessories tab of a collection home carry the dot too */
  (function () {
    var ctx = bar.getAttribute('data-ctx') || '';
    function key(q) { var o = []; q.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'tag' || k === 'pb_sort' || k === 'view') o.push(k + '=' + v); }); return o.sort().join('&'); }
    var lp = location.pathname.replace(/\/$/, '') || '/', lk = key(new URLSearchParams(location.search));
    function here(a) {
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return false; }
      if (u.origin !== location.origin) return false;
      var p = u.pathname.replace(/\/$/, '') || '/';
      if (p === lp) return key(u.searchParams) === lk && (!u.searchParams.get('sort_by') || u.searchParams.get('sort_by') === new URLSearchParams(location.search).get('sort_by'));
      return !!ctx && p === ctx && !u.search;
    }
    var shopHere = false;
    [].forEach.call(D.querySelectorAll('#pbt-shop a[href], #pbt-menu a[href]'), function (a) {
      if (a.closest('.pbt-hd') || a.classList.contains('pbt-bbtn') || a.classList.contains('pbt-back')) return;
      if (here(a)) { a.setAttribute('aria-current', 'page'); if (a.closest('#pbt-shop') && !a.classList.contains('pbt-h')) shopHere = true; }
    });
    /* the dot lives in the panel and drawer rows only, never on the header pills */
  })();

  /* source tracking: a product opened from the search panel (pb-search.js sets sessionStorage pb_src_pending) marks the
     next successful add to cart: cart attribute Source = src-search-bar, only when the cart has no Source yet */
  (function () {
    var KEY = 'pb_src_pending';
    function pending() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
    function setSource(src) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      if (window.PBSub && PBSub.cartSource) { PBSub.cartSource(src); return; }   /* the shared helper (assets/pb-sub.js) */
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (c && c.attributes && c.attributes.Source) return;
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { Source: src } }) });
      }).catch(function () {});
    }
    function hook() {
      if (window.__pbSrcHook || !window.fetch) return; window.__pbSrcHook = 1;
      var of = window.fetch;
      window.fetch = function (u, o) {
        var p = of.apply(this, arguments);
        try {
          var url = String((u && u.url) || u || '');
          if (/\/cart\/add(\.js)?(\?|$)/.test(url)) { var src = pending(); if (src) p.then(function (r) { if (r && r.ok) setSource(src); }, function () {}); }
        } catch (e) {}
        return p;
      };
    }
    window.pbSrcHook = hook;
    if (pending()) hook();
  })();

  /* drawer drill-down: Shop bags / Shop accessories (and Pins, Charms, Air fresheners under it) slide in as views over
     the menu, each with a Back row; the views under the top one are inert; the branch of the page you are on opens
     with the drawer (no slide), and every close resets them */
  var DV = {}; [].forEach.call(D.querySelectorAll('#pbt-menu .pbt-dv'), function (v) { DV[v.getAttribute('data-dv')] = v; });
  var dvStack = [];
  function dvRoot() { return P.m && P.m.querySelector('.pbt-scw > .pbt-sc'); }
  function dvTop() { return dvStack.length ? DV[dvStack[dvStack.length - 1]] : dvRoot(); }
  function dvOpen(name, instant) {
    var v = DV[name]; if (!v || dvStack.indexOf(name) !== -1) return;
    var under = dvTop();
    v.hidden = false; v.scrollTop = 0;
    if (instant) v.classList.add('no-anim');
    void v.offsetWidth;
    v.classList.add('is-in');
    if (instant) { void v.offsetWidth; v.classList.remove('no-anim'); }
    if (under) under.setAttribute('inert', '');
    dvStack.push(name);
    [].forEach.call(D.querySelectorAll('#pbt-menu [data-pbt-dd="' + name + '"]'), function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (!instant) setTimeout(function () { var bk = v.querySelector('[data-pbt-back]'); if (bk) try { bk.focus({ preventScroll: true }); } catch (e) { bk.focus(); } }, 60);
  }
  function dvBack() {
    var name = dvStack.pop(); if (!name) return;
    var v = DV[name]; v.classList.remove('is-in');
    setTimeout(function () { if (!v.classList.contains('is-in')) v.hidden = true; }, 460);
    var under = dvTop(); if (under) under.removeAttribute('inert');
    var opener = under && under.querySelector('[data-pbt-dd="' + name + '"]');
    [].forEach.call(D.querySelectorAll('#pbt-menu [data-pbt-dd="' + name + '"]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (opener) try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
  }
  function dvReset() {
    while (dvStack.length) { var n = dvStack.pop(), v = DV[n]; v.classList.add('no-anim'); v.classList.remove('is-in'); v.hidden = true; void v.offsetWidth; v.classList.remove('no-anim'); }
    var r = dvRoot(); if (r) r.removeAttribute('inert');
    [].forEach.call(D.querySelectorAll('#pbt-menu [data-pbt-dd]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function dvHere() {
    var a = D.querySelector('#pbt-menu .pbt-dv a[aria-current="page"]'); if (!a) return;
    var chain = [], v = a.closest('.pbt-dv');
    while (v) { chain.unshift(v.getAttribute('data-dv')); var par = v.getAttribute('data-parent'); v = par && par !== 'root' ? DV[par] : null; }
    chain.forEach(function (n) { dvOpen(n, true); });
  }
  /* you-are-here for the drill-down buttons: the branch holding the current page */
  [].forEach.call(D.querySelectorAll('#pbt-menu .pbt-dv a[aria-current="page"]'), function (a) {
    var v = a.closest('.pbt-dv');
    while (v) { var n = v.getAttribute('data-dv'); [].forEach.call(D.querySelectorAll('#pbt-menu [data-pbt-dd="' + n + '"]'), function (b) { b.classList.add('pbt-here'); }); var par = v.getAttribute('data-parent'); v = par && par !== 'root' ? DV[par] : null; }
  });
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest || !P.m || !P.m.contains(t)) return;
    var b = t.closest('[data-pbt-dd]'); if (b) { e.preventDefault(); dvOpen(b.getAttribute('data-pbt-dd')); return; }
    if (t.closest('[data-pbt-back]')) { e.preventDefault(); dvBack(); }
  });
  window.pbTopbarDv = { open: dvOpen, back: dvBack, reset: dvReset, here: dvHere };

  /* Shop panel: Pins / Charms / Air fresheners open their sub-list under the accessories list (one at a time); the one
     holding the current page opens with the panel */
  function sxSet(name, on) {
    [].forEach.call(D.querySelectorAll('#pbt-shop [data-pbt-sx]'), function (b) {
      var n = b.getAttribute('data-pbt-sx'), open = on && n === name, box = D.getElementById('pbt-sx-' + n);
      b.setAttribute('aria-expanded', open ? 'true' : 'false'); if (box) box.hidden = !open;
    });
    if (P.s) requestAnimationFrame(function () { cues(P.s); });
  }
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#pbt-shop [data-pbt-sx]'); if (!b) return;
    e.preventDefault(); sxSet(b.getAttribute('data-pbt-sx'), b.getAttribute('aria-expanded') !== 'true');
  });
  (function () {
    var a = D.querySelector('#pbt-shop .pbt-sx a[aria-current="page"]'); if (!a) return;
    var box = a.closest('.pbt-sx'), n = box && box.getAttribute('data-sx');
    if (n) { sxSet(n, true); [].forEach.call(D.querySelectorAll('#pbt-shop [data-pbt-sx="' + n + '"]'), function (b) { b.classList.add('pbt-here'); }); }
  })();

  /* back from a search-bar signup that needed a captcha: mark the signup and show the code once */
  (function () {
    var p = ''; try { p = sessionStorage.getItem('pbs_reveal') || ''; sessionStorage.removeItem('pbs_reveal'); } catch (e) {}
    if (!p || !/[?&]customer_posted=true/.test(location.search)) return;
    function show() {
      var code = (window.PBSub && PBSub.code) || ((D.querySelector('[data-pb-sub]') || { getAttribute: function () { return ''; } }).getAttribute('data-pb-sub-code')) || 'ITSINTHEBAG';
      try { if (window.PBSub && PBSub.mark) PBSub.mark('search'); localStorage.setItem('pbq_unlocked', '1'); } catch (e) {}
      var t = D.createElement('div');
      t.className = 'pbt-toast'; t.setAttribute('role', 'status');
      t.innerHTML = '<span>Your code: <b>' + code.replace(/[<>&"]/g, '') + '</b></span><button type="button" data-c>Copy</button><button type="button" data-x aria-label="Close">\u00d7</button>';
      t.style.cssText = 'position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:2147482500;display:flex;align-items:center;gap:10px;max-width:calc(100vw - 32px);box-sizing:border-box;padding:8px 8px 8px 16px;border-radius:999px;background:#fff;border:1px solid #d5ddf0;box-shadow:0 10px 30px rgba(11,22,48,.18);color:#003087;font:600 14px/1.2 \'Inter Tight\',system-ui,sans-serif;translate:-50% 0';
      D.body.appendChild(t);
      t.addEventListener('click', function (e) {
        if (e.target.closest('[data-x]')) { t.remove(); return; }
        if (e.target.closest('[data-c]')) { var b = e.target.closest('[data-c]'); var ok = function () { b.textContent = 'Copied'; }; if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok(); }
      });
      [].forEach.call(t.querySelectorAll('button'), function (b) { b.style.cssText = 'appearance:none;border:0;border-radius:999px;min-height:36px;padding:0 14px;background:#003087;color:#fff;font:inherit;cursor:pointer'; });
      t.querySelector('[data-x]').style.cssText = 'appearance:none;border:0;border-radius:999px;width:36px;height:36px;background:none;color:#003087;font-size:20px;cursor:pointer';
    }
    if (D.readyState === 'complete') show(); else window.addEventListener('load', show);
  })();

  /* cart: the drawer when the store has one */
  var cart = D.getElementById('pbt-cart');
  if (cart) cart.addEventListener('click', function (e) {
    close(false);
    if (!cart.hasAttribute('aria-controls') || location.pathname === '/cart') return;
    var mc = store('xMiniCart'); if (!mc) return;
    e.preventDefault();
    if (mc.open) return;
    try { var md = store('xModal'); if (md) md.setActiveElement('pbt-cart'); } catch (x) {}
    mc.openCart();
  });

  /* tabs */
  var seg = D.getElementById('pbt-seg');
  var tabs = seg ? [].slice.call(seg.querySelectorAll('[data-pbt-tab]')) : [];
  var thumb = seg && seg.querySelector('.pbt-thumb');
  var act = null;
  function paint(k) {
    act = k;
    tabs.forEach(function (t) { if (t.getAttribute('data-pbt-tab') === k) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    var at = null; tabs.forEach(function (t) { if (t.getAttribute('data-pbt-tab') === k) at = t; });
    if (!thumb) return;
    if (at && at.getClientRects().length) {
      var sr = seg.getBoundingClientRect(), r = at.getBoundingClientRect();
      thumb.style.transform = 'translate(' + Math.round(r.left - sr.left) + 'px,' + Math.round(r.top - sr.top) + 'px)';
      thumb.style.width = Math.round(r.width) + 'px'; thumb.style.height = Math.round(r.height) + 'px';
      thumb.classList.add('is-on');
    } else thumb.classList.remove('is-on');
  }
  var home = bar.getAttribute('data-home') === '1';
  /* homepage: the mark pill holds the navy thumb at the top (you are home); it travels to Bags / Accessories as their
     sections arrive, and back on the way up */
  paint(bar.getAttribute('data-area') || (home ? 'home' : null));
  requestAnimationFrame(function () { requestAnimationFrame(function () { if (seg) seg.classList.add('is-ready'); }); });
  if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { paint(act); });
  var paintW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth === paintW) return; paintW = window.innerWidth; paint(act); }, { passive: true });

  var spyHold = false;   /* the scroll-spy waits while a tab's eased scroll runs */
  function sec(id) { return D.querySelector('[id$="__' + id + '"].shopify-section') || D.querySelector('[id$="__' + id + '"]'); }
  if (home) {
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (t.getAttribute('data-pbt-tab') === 'home') {
          e.preventDefault(); close(false); paint('home'); spyHold = true;
          easeScroll(0, function () { setTimeout(function () { spyHold = false; }, 120); });
          return;
        }
        var id = t.getAttribute('data-pbt-go'), s = sec(id), fb = false;
        if (!s && id === 'accessorise') { s = sec('accessorise-rows'); fb = true; }   /* the rows replaced the old Accessorise grid (src M-699F) */
        if (!s) return;
        e.preventDefault(); close(false);
        paint(t.getAttribute('data-pbt-tab'));   /* at once, before the scroll */
        spyHold = true;
        var settle = function () { setTimeout(function () { spyHold = false; }, 120); };
        /* the opening statement's link knows the homepage animation (it skips the shockwave for this one scroll);
           let it set that up, then run its scroll eased instead of the browser's quick smooth scroll */
        var via = fb ? null : D.querySelector('.pbcv__open [data-open-go="' + id + '"]');
        if (via) {
          var st = window.scrollTo, got = null;
          window.scrollTo = function (o, y2) { got = (o && typeof o === 'object') ? o.top : y2; };
          try { via.click(); } finally { window.scrollTo = st; }
          if (got != null && isFinite(got)) easeScroll(function () { return Math.round(s.getBoundingClientRect().top + (window.pageYOffset || 0) - bar.offsetHeight); }, settle);
          else settle();
          return;
        }
        easeScroll(function () { return Math.round(s.getBoundingClientRect().top + (window.pageYOffset || 0) - bar.offsetHeight); }, settle);
      });
    });
    var sb = null, sa = null, rq = 0;
    function track() {
      rq = 0;
      if (spyHold) return;
      if (!sb) sb = sec('core-three'); if (!sa) sa = sec('accessorise') || sec('accessorise-rows');
      /* the mark (navy) means the top of the page only: past the bag sections no tab is lit, so it never reads as back at the top */
      var probe = bar.getBoundingClientRect().bottom + 40, k = null;
      var ra = sa && sa.getBoundingClientRect(), rb = sb && sb.getBoundingClientRect();
      if (ra && ra.top <= probe && ra.bottom > probe) k = 'acc';
      else if (rb && rb.top <= probe && (!ra || ra.top > probe)) k = 'bags';
      else if (!rb || rb.top > probe) k = 'home';
      if (k !== act) paint(k);
    }
    window.addEventListener('scroll', function () { if (!rq) rq = requestAnimationFrame(track); }, { passive: true });
    window.addEventListener('load', track);
    track();
  }
})();

/* Pinned menu bars (collection filter bar, Bundle and Save steps): while one is stuck under the header, the strip
   between it and the top of the screen is solid white (a white shadow drawn upward), so nothing scrolls through
   the glass header above it. A 1px sentinel before each bar tells when it is stuck; no scroll handler. */
(function () {
  if (window.__pbStickCover || !window.IntersectionObserver) return;
  window.__pbStickCover = 1;
  var SEL = '#header-filter, .pbbb-prog';
  var css = document.createElement('style');
  css.textContent = '.pb-stuck{box-shadow:0 calc(-1 * var(--pbsc, 64px)) 0 #fff, 0 calc(-.5 * var(--pbsc, 64px)) 0 #fff !important}';
  document.head.appendChild(css);
  function arm(el) {
    if (el.__pbsc) return; el.__pbsc = 1;
    var top = parseFloat(getComputedStyle(el).top) || 0;
    el.style.setProperty('--pbsc', Math.max(8, Math.round(top) + 2) + 'px');
    var s = document.createElement('div');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'height:1px;margin-bottom:-1px;visibility:hidden;pointer-events:none';
    el.parentNode.insertBefore(s, el);
    var io = new IntersectionObserver(function (es) {
      var e = es[es.length - 1], stuck = !e.isIntersecting && e.boundingClientRect.top < top + 4;
      if (el.classList.contains('pb-stuck') !== stuck) el.classList.toggle('pb-stuck', stuck);
    }, { rootMargin: '-' + (Math.round(top) + 3) + 'px 0px 0px 0px', threshold: 0 });
    io.observe(s);
  }
  function scan() { [].forEach.call(document.querySelectorAll(SEL), arm); }
  scan();
  window.addEventListener('load', scan);
  setTimeout(scan, 1500);
})();

/* B-grade explained: every short label that names B-grade (finder "B-grade only", bundle cards, compare notes, variant
   pills and options) gets an (i) with the definition. Labels inside a button get the (i) after the button group. Runs on
   load and when cards are rendered later (one debounced childList observer). */
(function () {
  if (window.__pbBgrade) return;
  window.__pbBgrade = 1;
  var TXT = 'B-grade bags have been used as display models. They have minor cosmetic marks and are perfectly functional.';
  var RX = /\bb[\s-]?grade\b/i;
  var css = document.createElement('style');
  /* PB-1264: the (i) is the shared info tip (snippets/pb-info-tip, rendered once per page by snippets/pb-topbar): same icon,
     same navy panel, opens by tap or hover, closes on an outside tap or Esc. Only the row style lives here. */
  css.textContent = '.pb-bgt{display:inline;margin-left:4px}' +
    '.pb-bgt-row{display:flex;align-items:center;gap:4px;margin:6px 0 0;font:500 13px/1.3 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);color:#475583}' +
    '@media (max-width:749px){.pb-bgt__b{font-size:14px}.pb-bgt-row{font-size:14px}}';
  document.head.appendChild(css);
  var ICON = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.5" fill="none"/><path d="M8 7.2v4" fill="none" stroke-linecap="round"/><path d="M8 4.8v.1" fill="none" stroke-linecap="round" stroke-width="2"/></svg>';
  function tip() {
    var w = document.createElement('span');
    w.className = 'pb-it pb-bgt';
    w.innerHTML = '<button type="button" class="pb-it__b" aria-expanded="false" aria-label="What is B-grade?">' + ICON + '</button><span class="pb-it__t">' + TXT + '</span>';
    return w;
  }
  var SKIP = 'script,style,select,option,textarea,input,[contenteditable],.pb-bgt,.pb-bgt-row,[aria-hidden="true"],template,noscript,.pbbb__sheet [data-pbbb-body] small,.rte,.prose,[class*="description"],.product__description,.pb-story-desc,.pbst__body';
  function scan(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) {
      var t = n.nodeValue; if (!t || t.length > 90 || !RX.test(t)) continue;
      var el = n.parentElement; if (!el || el.closest(SKIP)) continue;
      if (el.closest('.pb-bgt-done')) continue;
      var vis = el.getClientRects().length; if (!vis) continue;
      hits.push(el);
    }
    hits.forEach(function (el) {
      if (el.closest('.pb-bgt-done')) return;
      var btn = el.closest('button,a,label,[role="radio"],[role="button"],summary');
      if (btn) {
        /* one (i) row after the group of choices, not inside the button */
        var grp = btn.parentElement; if (!grp || grp.querySelector(':scope > .pb-bgt-row') || (grp.nextElementSibling && grp.nextElementSibling.classList.contains('pb-bgt-row'))) { btn.classList.add('pb-bgt-done'); return; }
        var row = document.createElement('p'); row.className = 'pb-bgt-row'; row.appendChild(document.createTextNode('What is B-grade?')); row.appendChild(tip());
        grp.insertAdjacentElement('afterend', row); btn.classList.add('pb-bgt-done');
      } else {
        el.classList.add('pb-bgt-done'); el.appendChild(tip());
      }
    });
  }
  function go() { try { scan(document.body); } catch (e) {} }
  if (document.readyState !== 'loading') setTimeout(go, 600); else document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 600); });
  window.addEventListener('load', function () { setTimeout(go, 400); });
  var T = 0;
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { clearTimeout(T); T = setTimeout(go, 350); return; }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Zoom safety (pinch zoom on phones, browser zoom on desktop). Zooming re-rasterises every composited layer at the
   new scale (backdrop blurs, will-change layers, animated and rotating groups, canvases) and the page can run out
   of memory and reload or crash. While the page is zoomed in, those effects are switched off and the animations pause;
   they come back when the zoom returns to normal. Nothing here runs per frame: it reacts to the viewport events. */
(function () {
  if (window.__pbZoomSafe) return; window.__pbZoomSafe = 1;
  var H = document.documentElement, base = window.devicePixelRatio || 1, on = false, t = 0;
  var st = document.createElement('style');
  st.textContent = 'html.pb-zoomed *,html.pb-zoomed *::before,html.pb-zoomed *::after{animation-play-state:paused!important;will-change:auto!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;transition-duration:0s!important}' +
    'html.pb-zoomed canvas{visibility:hidden!important}html.pb-zoomed .sh__cv{animation:none!important;transform:none!important}';
  document.head.appendChild(st);
  function check() {
    var vv = window.visualViewport, scale = vv ? vv.scale : 1, dpr = window.devicePixelRatio || 1;
    var z = scale > 1.04 || Math.abs(dpr / base - 1) > 0.12;
    if (z !== on) { on = z; H.classList.toggle('pb-zoomed', z); }
  }
  function soon() { clearTimeout(t); t = setTimeout(check, 120); }
  if (window.visualViewport) { visualViewport.addEventListener('resize', soon, { passive: true }); }
  window.addEventListener('resize', soon, { passive: true });
  check();
})();
